import React from 'react'
import cx from 'classnames'

import { reportToggleFiltersPanel } from '../../../../common/analytics/filtersAnalytics'
import ShowFilters from '../../icons/showFilters'

import styles from './index.module.css'

const ToggleButton = ({ expanded, toggleSidebar, activeFiltersCount }) => {
  const buttonClass = cx(styles.buttonToggle, {
    [styles.active]: expanded,
    [styles.deactive]: !expanded
  })

  const extendedLabelClass = cx(styles.label, styles.hideOnMobile)

  const filtersCounter = cx(styles.label, styles.hideOnDesktop)

  const onClickHandler = () => {
    document.body.classList.toggle('mobileScrollLock')
    reportToggleFiltersPanel(expanded)
    toggleSidebar()
  }

  return (
    <div className={styles.toggleContainer}>
      <button
        className={buttonClass}
        onClick={onClickHandler}
        data-test-selector="toggle-filters-panel"
      >
        <ShowFilters
          width="18"
          height="18"
          className={styles.showFiltersIcon}
        />
        <span className={styles.label}>Filter</span>
        {activeFiltersCount !== 0 && (
          <span className={filtersCounter}>({activeFiltersCount})</span>
        )}
        <span className={extendedLabelClass}>& Refine</span>
      </button>
    </div>
  )
}

export default ToggleButton
